import { observable } from 'mobx'
import { REALNAME_AUTH_PATH_A, CENTER_REAL_NAME } from '@constant'
import { getMerchantInfo } from '@util'
import { message } from 'hljd'
import api from '@api/a_mao/shangshangqian'
class Store {
  @observable isVisiable = false
  @observable ShangshangqianInfo = {}
  @observable buttonText = '确认无误，去签字'
  @observable showClose = false
  checkSigned = async type => {
    const { success, data } = await api.checkSigned()
    const { sign, merchant = {} } = data
    if (success) {
      if (sign) {
        this.isVisiable = false
      } else {
        this.isVisiable = true
        this.showClose = false
        this.ShangshangqianInfo = merchant
        if (type) {
          message.warning('请确认您的签署状态')
        }
      }
    }
  }
  sign = async () => {
    this.buttonText = '合同正在生成中'
    const { success, data } = await api.buildBuild()
    this.buttonText = '确认无误，去签字'
    if (success) {
      const { url } = data
      this.showClose = true
      window.open(url)
    }
  }
  edit = () => {
    const { examine } = this.ShangshangqianInfo
    // 判断1+1审核是否通过
    if (examine) {
      window.location.href = REALNAME_AUTH_PATH_A
    } else {
      const info = getMerchantInfo()
      const { shop_type, property_id } = info
      window.location.href = `${CENTER_REAL_NAME}?property_id=${property_id}&shop_type=${shop_type}`
    }
  }
}
export default Store
